// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__LJYSK","logoSpan":"Logo_logoSpan__sXvF5","logoSubtext":"Logo_logoSubtext__N+KbB"};